import { convertCard } from '../reducers/handReducer';

export const connectSocket = () => ({
	type: 'CONNECT_SOCKET',
});

export const leaveGame = () => ({
	type: 'LEAVE_GAME',
});

export const joinQueue = (queueOptions) => ({
	type: 'JOIN_QUEUE',
	queueOptions,
});

export const startGame = () => ({
	type: 'START_GAME',
});

export const playCard = (card) => ({
	type: 'PLAY_CARD',
	card: convertToCard(card),
});

const convertToCard = (card) => {
	const type = {
		heart: 0,
		nut: 1,
		leave: 2,
		bell: 3,
	};
	const value = {
		jack: 2, //0,
		queen: 3, //1,
		king: 4, //2,
		septar: 7, //3,
		optar: 8, //4,
		nine: 9, //5,
		ten: 10, //6,
		ace: 11, //7,
	};
	console.log(card.suit);
	console.log({
		suite: type[card.suit],
		value: value[card.card],
	});
	return {
		suite: type[card.suit],
		value: value[card.card],
	};
};
